import styled from 'styled-components';
import { Buttons, Chip, FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: 1rem;
  border-radius: 14px;
  height: 100%;
`;

export const ButtonsContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  margin-top: 10px;
  label {
    font-weight: 450;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ButtonsActions = styled(Buttons.Classic)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
`;

export const ChipBanner = styled(Chip)`
  max-width: 400px;
  height: auto;
  padding: ${({ theme: { spacing } }) => spacing.spacing_08};
`;

export const BulletsContainer = styled.div`
  div {
    gap: 0;
  }
  svg {
    width: 24px;
    height: 16px;
  }
`;
